module.exports = __webpack_public_path__ + "img/2.5a8e1ad7.jpg";